export default __webpack_public_path__ + "static/media/skip_logo.8c7aabc2.svg";